export const Wellness = 
{
    Metadata:{Name:'Wellness',maxColumn:4,numRows:11},
    Sections:
    [
        {
            Headers:[
                "Please rate the following factors in your life over the <span class='importantText'>previous 24 months.</span>",
                "Strongly Disagree",
                "Disagree",
                "Agree",
                "Strongly Agree"
            ],
            Questions:[
                {
                    Prompt:"1. I feel safe in my home, workplace and Community",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. I feel my work is secure",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. I am able to meet my financial obligations.",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. My housing is secure",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. I have a support system: including one or more friends, family, and work colleagues.",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. I am able to afford and take my medications as prescribed.",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. I have access to healthy food I enjoy.",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. I have not had any legal concerns.",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. I can live independently: I do not need assistance bathing, dressing, or feeding myself.",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. I have consistent and safe transportation.",
                    Responses:[
                        {Value:'Strongly Disagree',Type:"radio"},
                        {Value:'Disagree',Type:"radio"},
                        {Value:'Agree',Type:"radio"},
                        {Value:'Strongly Agree',Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "No Diploma",
                "High School Diploma",
                "Some College",
                "College Degree"
            ],
            Questions:[
                {
                    Prompt:"11. My highest level of education",
                    Responses:[
                        {Value:'No Diploma',Type:"radio"},
                        {Value:'High School Diploma',Type:"radio"},
                        {Value:'Some College',Type:"radio"},
                        {Value:'College Degree',Type:"radio"}
                    ]
                },
            ]
        }
    ]
}